import {
	FAVORITE_ADDRESS_TUTORIAL_STAGE_PROGRESS,
	FAVORITE_ADDRESS_TUTORIAL_STAGES,
	getStorageKey,
} from '../constants';
import type {FavoriteAddressTutorialStage} from '../types';

export function getCurrentTutorialStage(loggedUserCode?: string): FavoriteAddressTutorialStage {
	const currentStage = FAVORITE_ADDRESS_TUTORIAL_STAGE_PROGRESS.find(
		({steps, completionMode = 'all'}) => {
			const isStepCompleted = (step: (typeof steps)[number]) => {
				return localStorage.getItem(getStorageKey(step, loggedUserCode)) === 'true';
			};

			const isStageCompleted =
				completionMode === 'any'
					? steps.some(isStepCompleted)
					: steps.every(isStepCompleted);

			return !isStageCompleted;
		},
	)?.stage;

	if (currentStage) {
		return currentStage;
	}

	return FAVORITE_ADDRESS_TUTORIAL_STAGES.COMPLETED;
}
